/**
 * Pathnames that use the shared authenticated-app shell (providers + splash lifecycle).
 * Keep this narrow — do not treat all app routes as authenticated shell.
 */
export function isAuthenticatedAppShellPath(pathname: string): boolean {
  if (!pathname) return false
  return (
    pathname === '/app-beta' ||
    pathname.startsWith('/app-beta/') ||
    pathname === '/travel' ||
    pathname.startsWith('/travel/')
  )
}
